import Aura from '@primeng/themes/aura';
import { definePreset } from '@primeng/themes';

export const DefaultTheme = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#f9f9f9',
      100: '#f1f1f1',
      200: '#e0e0e0',
      300: '#c2c2c2',
      400: '#969696',
      500: '#242424',
      600: '#595959',
      700: '#454545',
      800: '#333333',
      900: '#242424',
      950: '#141414'
    },
    colorScheme: {
      light: {
        surface: {
          0: '#FFFFFF',
          50: '#F9F9F9',
          100: '#E0E0E0',
          200: '#D1D1D1',
          300: '#C2C2C2',
          400: '#A9A9A9',
          500: '#969696',
          600: '#777777',
          700: '#595959',
          800: '#3C3C3C',
          900: '#242424',
          950: '#161616'
        }
      },
      dark: {
        surface: {
          0: '#ffffff',
          50: '#fafafa',
          100: '#f4f4f5',
          200: '#e4e4e7',
          300: '#d4d4d8',
          400: '#a1a1aa',
          500: '#71717a',
          600: '#52525b',
          700: '#3f3f46',
          800: '#27272a',
          900: '#18181b',
          950: '#09090b'
        }
      }
    }
  }
});
